export default {"src":"/_next/static/media/seo.026e8728.svg","height":160,"width":160};